import * as Scroll from 'react-scroll';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import GhLogo from "./images/gh-logo.png";
import LILogo from "./images/linkedin-logo.svg";
import logo from './images/logo.svg';
import Casey from "./images/casey-face.png";
import DownArrow from "./images/down-arrow.svg";
import NavBar from "./components/navbar";
import About from "./views/about";
import Design from "./views/design";
import Contact from "./views/contact";
import Footer from "./components/footer";
import Reveal from "./components/Reveal";
import Lines from "./images/lines.svg";

import './css/app.css';

function App() {
  return (
    <div>
      <img className="lines-art-right" src={Lines} alt="" aria-hidden="true"/>
      <NavBar/>
      <div className="hero-wrap">
      <header className="header-section container">
        <div className="hero-grid">
          <div className="hero-copy">
            <span className="availability-pill"><span className="dot" aria-hidden="true"></span>Open to new opportunities</span>
            <h1>Casey Alvarez</h1>
            <h3 className="text-dark hero-role">software engineer</h3>
            <p className="hero-intro my-4">Passionate software engineer with a knack for creating intuitive, engaging UX/UI. I turn design concepts into seamless, dynamic products, with AI woven into my daily workflow to ship better work, faster.</p>
            <div className="hero-ctas">
              <Link to="about" className="button button-primary" smooth={true} duration={500}>See my experience</Link>
              <Link to="contact" className="button button-secondary" smooth={true} duration={500}>Get in touch</Link>
            </div>
            <div className="social-logos hero-social">
              <a href="https://github.com/CaseyAlvarez" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">
                <img src={GhLogo} alt="GitHub"/>
              </a>
              <a href="https://www.linkedin.com/in/casey-alvarez-28a92123/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
                <img src={LILogo} alt="LinkedIn"/>
              </a>
            </div>
          </div>
          <div className="hero-media">
            <img src={Casey} className="main-headshot" alt="Casey Alvarez"/>
          </div>
        </div>
      </header>
      <Link className="scroll-cue" to="about" delay={0} smooth={false} offset={0} duration={500}>
        <div className="text-center">
          <p className="pointer text-center mb-0">scroll</p>
          <img className="pointer scroll-arrow" src={DownArrow} alt="" aria-hidden="true"/>
        </div>
      </Link>
      </div>
      <Reveal><About/></Reveal>
      <Reveal><Design/></Reveal>
      <Reveal><Contact/></Reveal>
      <Footer/>
    </div>
  );
}

export default App;
